import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import User from "../../stores/UserStore";
import General from "../../stores/GeneralStore";
import { Container } from "../login.screen/login.styled";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import { SpinnerRaw } from "../../components/spinner.component";
import { NotifySuccess } from "../../utils/ShowSuccess";


// const validationSchema = Yup.object().shape({
//   account: Yup.number().required("UserName is required"), // Use number validation rule
//   confirmpassword: Yup.string().required("Password is required").min(8,'min 8 chracters required'),
//   password: Yup.string().required("Password is required").min(8,'min 8 chracters required'),
// });


const VerifyEmail = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [resetCode,setResetCode] = useState<any>();
  useEffect(() => {
    // Get the current URL
    const currentURL = new URL(window.location.href);

    // Extract the "code" parameter from the URL
    const code = currentURL.searchParams.get('code');
    const username = currentURL.searchParams.get('username');
    handleSubmit(username,code);
    setResetCode(code)
    // Log the "code" parameter to verify

    // Now you can use the "code" parameter in your component
  }, []);


  
const [loader,setLoader]=useState(false);
  const handleSubmit = async (username: any,passwordResetCode:any) => {
    setLoader(true);
   const data= {
    emailVerificationCode:passwordResetCode,
      username
    }
    try {
    const res=  await User.verifyEmail({
        errorId: "resetPassword",
        data,
      });
      if(res?.result?.status){
        NotifySuccess(General?.codeLabels["cm_emailverificationsuccessmes"]?.label?General?.codeLabels["cm_emailverificationsuccessmes"]?.label:"Email Has Been Successfully Verified. Please Login")
        navigate('/')
      }
      setMessage("Reset Password request submitted successfully.");
      setLoader(false);
    } catch (error) {
      setLoader(false);
      setMessage("An error occurred while processing your request.");
    }
  };

  return (
    <Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100%",
        }}
        className="forgotusername-container"
      >
        <Box
          sx={{
            width:General?.isLargeScreen? "600px":"100%",
            padding: "50px",
            backgroundColor: "",
            color:'white'
          }}
        >
       <h1>{General?.codeLabels['cm_verifying_email']?.label?General?.codeLabels['cm_verifying_email']?.label:"Please wait verifying email..."}</h1>
        </Box>
      </Box>
    </Container>
  );
};

export default VerifyEmail;
